var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { InfraTurmaActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let InfraTurmaModule = class InfraTurmaModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = InfraTurmaActions.POST_TURMA](data) {
        return new Promise(resolve => {
            infraService.post("Turma/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = InfraTurmaActions.PUT_TURMA](data) {
        return new Promise(resolve => {
            infraService.put("Turma/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = InfraTurmaActions.DELETE_TURMA](data) {
        return new Promise(resolve => {
            infraService.delete("Turma/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = InfraTurmaActions.DELETE_RANGE_TURMA](data) {
        return new Promise(resolve => {
            infraService.delete("Turma/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = InfraTurmaActions.FILTER_TURMA](data) {
        return new Promise(resolve => {
            infraService.post("Turma/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = InfraTurmaActions.GET_TURMA]() {
        return new Promise(resolve => {
            infraService.get("Turma/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = InfraTurmaActions.GETWITHDISABLED_TURMA]() {
        return new Promise(resolve => {
            infraService.get("Turma/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = InfraTurmaActions.GET_BY_ID_TURMA](data) {
        return new Promise(resolve => {
            infraService.get("Turma/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], InfraTurmaModule.prototype, _h, null);
InfraTurmaModule = __decorate([
    Module
], InfraTurmaModule);
export default InfraTurmaModule;
//# sourceMappingURL=TurmaModule.js.map